import { axiosRef } from 'config/axios';

export const fetchGlobalInfo = ({ authToken }) => {
  return new Promise((resolve, reject) => {
    axiosRef.get('info', {
      headers: {
        'Authorization': `Bearer ${authToken}`,
      },
    }).then(({ data }) => {
      resolve(data);
    }).catch(error => {
      reject(error);
    });
  });
};
